import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { PaginatedSchedulerRow } from "./../../types/global";
import { boxHeight, dayWidth, weekWidth, monthWidth } from "./../../constants";

dayjs.extend(utc);

export const drawBlockedCells = (
    ctx: CanvasRenderingContext2D,
    zoom: number,
    rows: number,
    cols: number,
    parsedStartDate: { year: number; month: number; dayOfMonth: number },
    data: PaginatedSchedulerRow[]
) => {
    // largura de um dia padrão
    let unitDayWidth = dayWidth;
    if (zoom === 2 || zoom === 3) unitDayWidth = weekWidth / 7; // semanal
    if (zoom === 0) unitDayWidth = weekWidth / 7; // trimestral (mostrado em semanas)
    if (zoom === 4) unitDayWidth = monthWidth / 30; // anual (mostrado em meses aproximados)

    let currentY = 0;

    const timelineStart = dayjs.utc(
        `${parsedStartDate.year}-${parsedStartDate.month + 1}-${parsedStartDate.dayOfMonth}`
    ).startOf("day");

    data.forEach((row) => {
        const blocks = row.allocationBlocks || [];
        const rowHeight = Math.max(row.data.length, 1) * boxHeight;

        blocks.forEach(block => {
            const blockStart = dayjs.utc(block.startDate).startOf("day");
            const blockEnd = dayjs.utc(block.endDate).endOf("day");

            // posição inicial
            const startDiffDays = blockStart.diff(timelineStart, "days");
            const x = startDiffDays * unitDayWidth;

            // largura do bloco ajustada por zoom
            let width: number;
            if (zoom === 0) {
                // trimestral: largura proporcional a semanas
                const durationWeeks = blockEnd.diff(blockStart, "weeks", true);
                width = durationWeeks * weekWidth;
            } else if (zoom === 4) {
                // anual: largura proporcional a meses
                const durationMonths = blockEnd.diff(blockStart, "months", true);
                width = durationMonths * monthWidth;
            } else {
                // diário ou semanal
                const durationDays = blockEnd.diff(blockStart, "days") + 1;
                width = durationDays * unitDayWidth;
            }

            const canvasWidth = cols * (zoom === 1 ? dayWidth : (zoom === 2 || zoom === 3 ? weekWidth : monthWidth));

            if (x + width >= 0 && x < canvasWidth) {
                ctx.fillStyle = "rgba(128, 128, 128, 0.3)";
                ctx.fillRect(x, currentY, width, rowHeight);
            }
        });

        currentY += rowHeight;
    });
};
